import Send from './axiosUtils'
import moment from 'moment'
import utils from '../assets/js/utils'

export default {
  getSignUpToken () {
    // axios 요청을 생성합니다.
    /*
    axios 요청을 생성합니다.
    https://github.com/axios/axios axios API 챕터
    인터셉터를 안썼으면 다음과 같습니다.
    axios({
        baseURL: 'https://api.hnpwa.com',
        url: '/news/1.json',
        method: 'get'
    })
    */

    let form = new FormData()
    form.append('grant_type', 'client_credentials')

    return Send({
      url: '/api/oauth/token',
      method: 'post',
      data: form,
      tokenType: 'signUpToken'
    })
  },
  async postSignUp (payload) {
    let form = new FormData()
    form.append('identifier', payload.email)
    form.append('password', payload.password)
    form.append('joinType', payload.joinType)
    if(payload.certificate != null) {
      form.append('certImage', await utils.imgResize(payload.certificate), 'certImg.png')
    }
    form.append('agreeLocation', payload.agreeLocation)
    form.append('agreePromotion', payload.agreePromotion)

    return Send({
      url: '/api/ad/user/create',
      method: 'post',
      data: form,
      signUpToken: payload.signUpToken
    })
  },
  async getFindPwd (payload) {
    return Send({
      url: '/api/users/password/email?email=' + payload.email,
      method: 'get',
      type: 'public'
    })
  },
  getOauthToken (payload) {
    let form = new FormData()
    form.append('username', payload.email)
    form.append('password', payload.password)
    // form.append('username', 'kang2@gwh.co.kr')
    // form.append('password', 'a12345678')
    // form.append('username', 'test123@gwh.co.kr')
    // form.append('password', 'test123!!@@')
    // form.append('username', 'kang10@gwh.co.kr')
    // form.append('password', 'a12345678!')
    form.append('grant_type', 'password')
    form.append('scope', 'read write')

    return Send({
      url: '/api/oauth/token',
      method: 'post',
      data: form,
      tokenType: 'accessToken'
    })
  },
  getAdUserInfo () {
    return Send({
      url: '/api/ad/user/myInfo',
      method: 'get'
    })
  },
  getExposedChartData () {
    return Send({
      url: '/api/ad/user/stats/impression',
      method: 'get'
    })
  },
  getAnsweredChartData () {
    return Send({
      url: '/api/ad/user/stats/posting',
      method: 'get'
    })
  },
  getAdFeeChartData () {
    return Send({
      url: '/api/ad/user/stats/expense',
      method: 'get'
    })
  },
  getRegionList () {
    return Send({
      url: '/api/place/region/list?countryId=111',
      method: 'get',
      type: 'public'
    })
  },
  getDistrictList (payload) {
    return Send({
      url: '/api/place/district/list?regionId=' + payload.regionId,
      method: 'get'
    })
  },
  getAllDistrictList () {
    return Send({
      url: '/api/place/district/list?countryId=111',
      method: 'get',
      type: 'public'
    })
  },
  async postAdCreate (payload) {
    let form = new FormData()
    form.append('questionText', payload.find(items => items.type === 'titleText').value)
    if(payload.find(items => items.type === 'titleImg').value != null) {
      let questionSource = payload.find(items => items.type === 'titleImg').value
      form.append('questionSource', await utils.imgResize(questionSource), 'questionSource.png')
    }
    form.append('category', payload.find(items => items.type === 'category').value)
    form.append('targetGroup', payload.find(items => items.type === 'toward').value)
    form.append('targetGender', payload.find(items => items.type === 'gender').value)
    form.append('targetJobs', utils.setUnpackedJobs(payload.find(items => items.type === 'job').value))
    form.append('targetAgeGroups', utils.setUnpackedAges(payload.find(items => items.type === 'age').value))
    form.append('targetAreas', utils.setUnpackedAreas(payload.find(items => items.type === 'area').value))
    form.append('rewardType', payload.find(items => items.type === 'reward').value)
    form.append('startAt', payload.find(items => items.type === 'period').startDate)
    let endAt = payload.find(items => items.type === 'period').endDate
    endAt.setDate(endAt.getDate() + 1)
    form.append('endAt', endAt)
    form.append('dailyBudget', payload.find(items => items.type === 'dailyBudget').value)

    let choiceImg = null
    let choiceText = null
    let answerCount = 0
    // 답변 배열 셋팅
    for(var i = 0; i < 4; i++) {
      choiceText = payload.find(items => items.type === 'answerText').value[i].choiceText
      choiceImg = payload.find(items => items.type === 'answerImg').value[i].choiceImg
      if(choiceText != null) {
        form.append('adChoices[' + answerCount + '].choiceText', choiceText)
      }
      if(choiceImg != null) {
        form.append('adChoices[' + answerCount + '].choiceImg', await utils.imgResize(choiceImg), 'choice' + i + 'Img.png')
      }
      // 선택지 제목 null이 아닐경우 answerCount 증가처리
      if(choiceText != null) {
        answerCount++
      }
    }

    let rewardType = payload.find(items => items.type === 'reward').value
    // 쿠폰 셋팅
    if (rewardType === 'COUPON' || rewardType === 'ALL') {
      form.append('rewardCoupons[0].title', payload.find(items => items.type === 'coupon').value.title)
      form.append('rewardCoupons[0].expiredDate', payload.find(items => items.type === 'coupon').value.expiredDate)
    }

    // 포인트 셋팅
    if (rewardType === 'POLLIDE_POINT' || rewardType === 'ALL') {
      form.append('rewardPoint', payload.find(items => items.type === 'pollidePoint').value)
    } else {
      form.append('rewardPoint', 0)
    }

    return Send({
      url: '/api/ad/create',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  async postAdTemporaryToCreate (payload, adId, beforeImgExist) {
    // 임시저장된 광고 올릴때 추가 파라미터들
    let isQuestionSourceChanged = false
    let changedAdChoicesImgIndex = [] // 임시저장때와 바뀐 선택지 인덱스

    let form = new FormData()
    form.append('questionText', payload.find(items => items.type === 'titleText').value)
    if(payload.find(items => items.type === 'titleImg').value != null) {
      // 등록되는 이미지가 있을 시
      let questionSource = payload.find(items => items.type === 'titleImg').value
      if(questionSource instanceof File) {
        // 임시저장된 이미지가 기존이미지에서 바뀌었을 시
        isQuestionSourceChanged = true
        form.append('questionSource', await utils.imgResize(questionSource), 'questionSource.png')
      }
    }else if(payload.find(items => items.type === 'titleImg').value == null && beforeImgExist.titleImg) {
      // 기존에 제목이미지가 있었지만 삭제 했을시
      isQuestionSourceChanged = true
    }
    form.append('category', payload.find(items => items.type === 'category').value)
    form.append('targetGroup', payload.find(items => items.type === 'toward').value)
    form.append('targetGender', payload.find(items => items.type === 'gender').value)
    form.append('targetJobs', utils.setUnpackedJobs(payload.find(items => items.type === 'job').value))
    form.append('targetAgeGroups', utils.setUnpackedAges(payload.find(items => items.type === 'age').value))
    form.append('targetAreas', utils.setUnpackedAreas(payload.find(items => items.type === 'area').value))
    form.append('rewardType', payload.find(items => items.type === 'reward').value)
    form.append('startAt', payload.find(items => items.type === 'period').startDate)
    let endAt = payload.find(items => items.type === 'period').endDate
    endAt.setDate(endAt.getDate() + 1)
    form.append('endAt', endAt)
    form.append('dailyBudget', payload.find(items => items.type === 'dailyBudget').value)

    let choiceImg = null
    let choiceText = null
    let answerCount = 0
    // 답변 배열 셋팅
    for(var i = 0; i < 4; i++) {
      choiceText = payload.find(items => items.type === 'answerText').value[i].choiceText
      choiceImg = payload.find(items => items.type === 'answerImg').value[i].choiceImg
      if(choiceText != null) {
        form.append('adChoices[' + answerCount + '].choiceText', choiceText)
      }
      if(choiceImg != null && choiceImg instanceof File) {
        // 임시저장된 이미지가 기존이미지에서 바뀌었을 시
        changedAdChoicesImgIndex.push(answerCount)
        form.append('adChoices[' + answerCount + '].choiceImg', await utils.imgResize(choiceImg), 'choice' + i + 'Img.png')
      }else if(choiceImg == null && beforeImgExist.answerImg[i]) {
        // 기존에 이미지가 있었지만 삭제되었을 시
        changedAdChoicesImgIndex.push(answerCount)
      }
      // 선택지 제목 null이 아닐경우 answerCount 증가처리
      if(choiceText != null) {
        answerCount++
      }
    }

    let rewardType = payload.find(items => items.type === 'reward').value
    // 쿠폰 셋팅
    if (rewardType === 'COUPON' || rewardType === 'ALL') {
      form.append('rewardCoupons[0].title', payload.find(items => items.type === 'coupon').value.title)
      form.append('rewardCoupons[0].expiredDate', payload.find(items => items.type === 'coupon').value.expiredDate)
    }

    // 포인트 셋팅
    if (rewardType === 'POLLIDE_POINT' || rewardType === 'ALL') {
      form.append('rewardPoint', payload.find(items => items.type === 'pollidePoint').value)
    } else {
      form.append('rewardPoint', 0)
    }

    // 추가 처리
    form.append('isQuestionSourceChanged', isQuestionSourceChanged)
    if(changedAdChoicesImgIndex.length !== 0) {
      form.append('changedAdChoicesImgIndex', changedAdChoicesImgIndex)
    }
    form.append('isCreateToTemporary', false)

    return Send({
      url: '/api/ad/' + adId + '/modify',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  async postTemporaryAdCreate (payload) {
    let questionText = payload.find(items => items.type === 'titleText').value
    let questionSource = payload.find(items => items.type === 'titleImg').value
    let category = payload.find(items => items.type === 'category').value
    let targetGroup = payload.find(items => items.type === 'toward').value
    let targetGender = payload.find(items => items.type === 'gender').value
    let targetJobs = utils.setUnpackedJobs(payload.find(items => items.type === 'job').value)
    let targetAgeGroups = utils.setUnpackedAges(payload.find(items => items.type === 'age').value)
    // 전체값 처리 및 중복 제거
    let targetAreas = utils.setUnpackedAreas(payload.find(items => items.type === 'area').value)
    let rewardType = payload.find(items => items.type === 'reward').value
    let rewardPoint = payload.find(items => items.type === 'pollidePoint').value
    let startAt = payload.find(items => items.type === 'period').startDate
    let endAt = payload.find(items => items.type === 'period').endDate
    let dailyBudget = payload.find(items => items.type === 'dailyBudget').value
    // 쿠폰 셋팅
    let couponTitle = payload.find(items => items.type === 'coupon').value.title
    let couponExpiredDate = payload.find(items => items.type === 'coupon').value.expiredDate

    let form = new FormData()
    if(questionText != null) {
      form.append('questionText', questionText)
    }
    if(questionSource != null) {
      form.append('questionSource', await utils.imgResize(questionSource), 'questionSource.png')
    }
    if(category != null) {
      form.append('category', category)
    }
    if(targetGroup != null) {
      form.append('targetGroup', targetGroup)
    }
    if(targetGender != null) {
      form.append('targetGender', targetGender)
    }
    if(targetJobs != null) {
      form.append('targetJobs', targetJobs)
    }
    if(targetAgeGroups != null) {
      form.append('targetAgeGroups', targetAgeGroups)
    }
    if(targetAreas != null) {
      form.append('targetAreas', targetAreas)
    }
    if(rewardType != null) {
      form.append('rewardType', rewardType)
    }
    if(couponTitle != null) {
      form.append('rewardCoupons[0].title', couponTitle)
    }
    // 보상포인트, 일일예산 기본값 0
    form.append('rewardPoint', rewardPoint)
    form.append('dailyBudget', dailyBudget)
    // 쿠폰 만료 날짜, 시작날짜, 끝날짜 기본값 new Date
    form.append('rewardCoupons[0].expiredDate', couponExpiredDate)
    form.append('startAt', startAt)

    endAt.setDate(endAt.getDate() + 1)
    form.append('endAt', endAt)

    let choiceImg = null
    let choiceText = null
    let answerCount = 0
    // 답변 배열 셋팅
    for(var i = 0; i < 4; i++) {
      choiceText = payload.find(items => items.type === 'answerText').value[i].choiceText
      choiceImg = payload.find(items => items.type === 'answerImg').value[i].choiceImg
      if(choiceText != null) {
        form.append('adChoices[' + answerCount + '].choiceText', choiceText)
      }
      if(choiceImg != null) {
        form.append('adChoices[' + answerCount + '].choiceImg', await utils.imgResize(choiceImg), 'choice' + i + 'Img.png')
      }
      // 선택지 이미지, 선택지 제목 둘 중 하나라도 null이 아닐경우 answerCount 증가처리
      if(choiceText != null || choiceImg != null) {
        answerCount++
      }
    }

    return Send({
      url: '/api/ad/save',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  async postTemporaryAdTemporary (payload, adId, beforeImgExist) {
    // 임시저장된 광고 올릴때 추가 파라미터들
    let isQuestionSourceChanged = false
    let changedAdChoicesImgIndex = [] // 임시저장때와 바뀐 선택지 인덱스

    let questionText = payload.find(items => items.type === 'titleText').value
    let questionSource = payload.find(items => items.type === 'titleImg').value
    let category = payload.find(items => items.type === 'category').value
    let targetGroup = payload.find(items => items.type === 'toward').value
    let targetGender = payload.find(items => items.type === 'gender').value
    let targetJobs = utils.setUnpackedJobs(payload.find(items => items.type === 'job').value)
    let targetAgeGroups = utils.setUnpackedAges(payload.find(items => items.type === 'age').value)
    // 전체값 처리 및 중복 제거
    let targetAreas = utils.setUnpackedAreas(payload.find(items => items.type === 'area').value)
    let rewardType = payload.find(items => items.type === 'reward').value
    let rewardPoint = payload.find(items => items.type === 'pollidePoint').value
    let startAt = payload.find(items => items.type === 'period').startDate
    let endAt = payload.find(items => items.type === 'period').endDate
    let dailyBudget = payload.find(items => items.type === 'dailyBudget').value
    // 쿠폰 셋팅
    let couponTitle = payload.find(items => items.type === 'coupon').value.title
    let couponExpiredDate = payload.find(items => items.type === 'coupon').value.expiredDate

    let form = new FormData()
    if(questionText != null) {
      form.append('questionText', questionText)
    }
    if(questionSource != null && questionSource instanceof File) {
      // 임시저장된 이미지가 기존이미지에서 바뀌었을 시
      isQuestionSourceChanged = true
      form.append('questionSource', await utils.imgResize(questionSource), 'questionSource.png')
    }else if(questionSource == null && beforeImgExist.titleImg) {
      // 기존에 이미지가 있었지만 삭제되었을 시
      isQuestionSourceChanged = true
    }
    if(category != null) {
      form.append('category', category)
    }
    if(targetGroup != null) {
      form.append('targetGroup', targetGroup)
    }
    if(targetGender != null) {
      form.append('targetGender', targetGender)
    }
    if(targetJobs != null) {
      form.append('targetJobs', targetJobs)
    }
    if(targetAgeGroups != null) {
      form.append('targetAgeGroups', targetAgeGroups)
    }
    if(targetAreas != null) {
      form.append('targetAreas', targetAreas)
    }
    if(rewardType != null) {
      form.append('rewardType', rewardType)
    }
    if(couponTitle != null) {
      form.append('rewardCoupons[0].title', couponTitle)
    }
    // 보상포인트, 일일예산 기본값 0
    form.append('rewardPoint', rewardPoint)
    form.append('dailyBudget', dailyBudget)
    // 쿠폰 만료 날짜, 시작날짜, 끝날짜 기본값 new Date
    form.append('rewardCoupons[0].expiredDate', couponExpiredDate)
    form.append('startAt', startAt)

    endAt.setDate(endAt.getDate() + 1)
    form.append('endAt', endAt)

    let choiceImg = null
    let choiceText = null
    let answerCount = 0
    // 답변 배열 셋팅
    for(var i = 0; i < 4; i++) {
      choiceText = payload.find(items => items.type === 'answerText').value[i].choiceText
      choiceImg = payload.find(items => items.type === 'answerImg').value[i].choiceImg
      if(choiceText != null) {
        form.append('adChoices[' + answerCount + '].choiceText', choiceText)
      }
      if(choiceImg != null && choiceImg instanceof File) {
        // 임시저장된 이미지가 기존이미지에서 바뀌었을 시
        changedAdChoicesImgIndex.push(answerCount)
        form.append('adChoices[' + answerCount + '].choiceImg', await utils.imgResize(choiceImg), 'choice' + i + 'Img.png')
      }else if(choiceImg == null && beforeImgExist.answerImg[i]) {
        // 기존에 이미지가 있었지만 삭제되었을 시
        changedAdChoicesImgIndex.push(answerCount)
      }
      // 선택지 이미지, 선택지 제목 둘 중 하나라도 null이 아닐경우 answerCount 증가처리
      if(choiceText != null || choiceImg != null) {
        answerCount++
      }
    }

    // 추가 처리
    form.append('isQuestionSourceChanged', isQuestionSourceChanged)
    if(changedAdChoicesImgIndex.length !== 0) {
      form.append('changedAdChoicesImgIndex', changedAdChoicesImgIndex)
    }
    form.append('isCreateToTemporary', true)

    return Send({
      url: '/api/ad/' + adId + '/modify',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  deleteTemporaryAd (payload) {
    return Send({
      url: '/api/ad/' + payload.adId + '/delete',
      method: 'delete'
    })
  },
  getMyAdList (payload) {
    let url = '/api/ad/myList?page=' + payload.adPage + '&size=' + payload.adListSize
    if (payload.searchText !== '' && payload.searchText != null) {
      url += '&searchText=' + payload.searchText
    }

    return Send({
      url: url,
      method: 'get'
    })
  },
  getAdCounts (payload) {
    let url = '/api/ad/counts/myList'
    if (payload.searchText !== '' && payload.searchText != null) {
      url += '?searchText=' + payload.searchText
    }

    return Send({
      url: url,
      method: 'get'
    })
  },
  getAdInfo (payload) {
    return Send({
      url: '/api/ad/' + payload.adId,
      method: 'get'
    })
  },
  async postModifyAdUserInfo (payload) {
    let form = new FormData()
    form.append('name', payload.name)
    form.append('address', payload.address)
    form.append('description', payload.description)
    for(var i = 0; i < payload.images.length; i++) {
      form.append('images[' + i + ']', await utils.imgResize(payload.images[i]), 'images' + i + '.png')
    }

    return Send({
      url: '/api/ad/user/myInfo',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  async postModifyAdUserInvoice (payload) {
    let form = new FormData()
    form.append('invoice', payload.invoice)

    return Send({
      url: '/api/ad/user/myInfo',
      method: 'post',
      data: form
    })
  },
  deleteAdUserImages (payload) {
    let data = {
      indices: payload.values
    }
    return Send({
      url: '/api/ad/user/image',
      method: 'delete',
      data: data
    })
  },
  async postModifyAdUserCertImage (payload) {
    let form = new FormData()
    form.append('certImage', await utils.imgResize(payload.certFile), 'certImg.png')

    return Send({
      url: '/api/ad/user/cert',
      method: 'post',
      data: form,
      type: 'blob'
    })
  },
  deleteAdUserCertImage () {
    return Send({
      url: '/api/ad/user/cert',
      method: 'delete'
    })
  },
  getFeeInfoList (payload) {
    let startAt = moment(payload.startAt).format('yyyy-MM-DD')
    let endAt = moment(payload.endAt).format('yyyy-MM-DD')

    return Send({
      url: '/api/ad/point/list?startAt=' + startAt + '&endAt=' + endAt,
      method: 'get'
    })
  },
  getFollowerInfo (payload) {
    return Send({
      url: '/api/follow/followers?page=' + payload.followerInfoPage + '&size=' + payload.followerInfoSize,
      method: 'get'
    })
  },
  getFollowerRequest (payload) {
    return Send({
      url: '/api/follow/requests?page=' + payload.followerRequestPage + '&size=' + payload.followerRequestSize,
      method: 'get'
    })
  },
  postFollowerAcceptApi (payload) {
    return Send({
      url: '/api/follow/request/' + payload.requestId + '/accept',
      method: 'post'
    })
  },
  postFollowerCancelApi (payload) {
    return Send({
      url: '/api/follow/request/' + payload.userId,
      method: 'delete'
    })
  },
  postFollowerRejectApi (payload) {
    return Send({
      url: '/api/follow/request/' + payload.requestId + '/reject',
      method: 'post'
    })
  },
  getAdStats (payload) {
    return Send({
      url: '/api/ad/' + payload.adId + '/stats',
      method: 'get'
    })
  },
  sendVerifyEmail (payload) {
    return Send({
      url: '/api/ad/user/verify?email=' + payload.email,
      method: 'get',
      type: 'public'
    })
  },
  postVerifyNumber (payload) {
    let form = new FormData()
    form.append('email', payload.email)
    form.append('key', payload.verifyNumber)

    return Send({
      url: '/api/ad/user/verify',
      method: 'post',
      data: form,
      type: 'public'
    })
  },
  getAdUserCouponCount () {
    return Send({
      url: '/api/ad/user/coupons',
      method: 'get'
    })
  },
  deleteAdUser () {
    return Send({
      url: '/api/ad/user/withdraw',
      method: 'delete'
    })
  },
  postMerchantData (payload) {
    let data = {
      pg: payload.pg,
      payMethod: payload.payMethod,
      amount: payload.amount
    }

    return Send({
      url: '/api/ad/user/payment/create',
      method: 'post',
      data: data
    })
  },
  postCompletePayment (payload) {
    let data = {
      impUid: payload.impUid,
      merchantId: payload.merchantId
    }

    return Send({
      url: '/api/ad/user/payment/complete',
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/axiosApis/apis.js